import "./styles.css";
import LogoPalmares from "../../Imagens/logoWhite.png";
import React, { useState, useEffect } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { AiOutlineLeftSquare } from "react-icons/ai";
import { AiOutlineAlert } from "react-icons/ai";
import { AiOutlineProfile } from "react-icons/ai";
import { TbMapSearch } from "react-icons/tb";
import { TbRouteAltLeft } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { IoCloseCircle } from "react-icons/io5";

const MenuLateral = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [nomeLogado, setnomeUsuarioLogado] = useState();
  const [IDLogado, setIDUsuarioLogado] = useState();
  const navigate = useNavigate();

  useEffect(function () {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }else{
      let dados = JSON.parse(localStorage.getItem('usuarioLogado'));
      setnomeUsuarioLogado(dados.pessoa.nome);
      let idFormatado = String(dados.IDusuario).padStart(6, '0');
      setIDUsuarioLogado(idFormatado);
    }
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
      <div className="menu-container">
        {/* Botão de hambúrguer para dispositivos móveis */}
        <div className="menu-toggle" onClick={toggleMenu}>
          <span className="menu-icon"></span>
          <span className="menu-icon"></span>
          <span className="menu-icon"></span>
        </div>

        {/* Menu lateral */}
        <nav className={`sidebar ${isOpen ? "open" : ""}`}>
          <div id="iconeMenu">
          <img id="imgLogo" src={LogoPalmares} alt="Logo Grupo Palmares"></img>
          <div id="dadosUsuario">
            <p className="titulodados"> <AiOutlineUser style={{fontSize:'14px'}} /> USUÁRIO:</p> 
            <p className="dados">{ nomeLogado }</p>
            <p className="titulodados"><AiOutlineLeftSquare style={{fontSize:'14px'}} /> ID. USUÁRIO:</p>
            <p className="dados">{ IDLogado }</p>
          </div>
          </div>
          <ul id="listamenu">
            <br/>
            <li><a href="/Mapa"><TbMapSearch  style={{fontSize:'28px', paddingRight:'5px'}}/>MAPA</a></li>
            <li><a href="/Menu"><AiOutlineProfile style={{fontSize:'28px', paddingRight:'5px'}}/>ENTREGAS</a></li>
            <li><a href="/Roteamento"><TbRouteAltLeft style={{fontSize:'28px', paddingRight:'5px'}}/>ROTEAMENTO</a></li>
            <li><a href="/Ocorrencias"><AiOutlineAlert style={{fontSize:'28px', paddingRight:'5px'}}/>OCORREENCIAS</a></li>
            <li><a href="/"><IoCloseCircle style={{fontSize:'28px', paddingRight:'5px'}}/>SAIR</a></li>
          </ul>
        </nav>
      </div>
  );
};

export default MenuLateral;
